<template>
	<div class="activities-subview">
		<div class="subviewOpts">
				<span class="button-link-group">
					<it-link :to="createContactLink" class="button-link"><sym-icon name="call"></sym-icon> {{ env.msg('menu.createContact') }}</it-link>
					<it-link :to="env.net.urlParam(createContactLink, 'days', 0)" class="button-link">{{ env.msg('bas.today').toLowerCase() }}</it-link>
					<it-link :to="env.net.urlParam(createContactLink, 'days', 1)" class="button-link">{{ env.msg('bas.tomorrow').toLowerCase() }}</it-link>
					<it-link v-for="ml in miniLinks" :key="ml.days" :to="ml.link" class="button-link">{{ ml.label }}</it-link>
				</span>
			<it-link :to="addContextParams('planEvent.do', ctx, EVENT_REFS)" class="button-link button-link-bicon"><sym-icon name="event"></sym-icon> {{ env.msg('menu.createEvent') }}</it-link>
			<it-link :to="addContextParams('createTask.do', ctx, TASK_REFS)" class="button-link button-link-bicon"><sym-icon name="task"></sym-icon> {{ env.msg('menu.createTask') }}</it-link>
		</div>
		<div id="activitiesSubview">
			<crm-table :rest-api="restApi"></crm-table>
		</div>
	</div>
</template>

<script setup lang="ts">
import {computed} from "vue";
import CrmTable from "@/vue/table/CrmTable.vue";
import {addContextParams, CONTACT_REFS, ContextKey, EVENT_REFS, getIntValue, hasValue, injectContext, TASK_REFS} from "@t/fd/AppContext.ts";
import {injectEnv} from "@fd/Environment.ts";
import ItLink from "@/router/ItLink.vue";
import SymIcon from "@fd/helpers/SymIcon.vue";
import {shiftDate} from "@t/util/DateUtil.ts";
import {weekdayShortName} from "@/event/calendar/Formating.ts";

const env = injectEnv();
const ctx = injectContext();
const sourceType = computed<number>(() => getIntValue(ctx.value, ContextKey.SRC_TYPE));
const sourceId = computed<string|number>(() => getIntValue(ctx.value, ContextKey.SRC_ID));


const restApi = computed<string>(() => {
	let ep = "api/activities/agendaSubview";
	ep = env.net.urlParam(ep, "srcType", sourceType.value);
	ep = env.net.urlParam(ep, "srcId", sourceId.value);
	const c = ctx.value;
	if (hasValue(c, ContextKey.CUSTOMER)) ep = env.net.urlParam(ep, "customerId", getIntValue(c, ContextKey.CUSTOMER));
	if (hasValue(c, ContextKey.BRANCH)) ep = env.net.urlParam(ep, "branchId", getIntValue(c, ContextKey.BRANCH));
	if (hasValue(c, ContextKey.PERSON)) ep = env.net.urlParam(ep, "personId", getIntValue(c, ContextKey.PERSON));
	if (hasValue(c, ContextKey.CAMPAIGN)) ep = env.net.urlParam(ep, "campaignId", getIntValue(c, ContextKey.CAMPAIGN));
	return ep;
});

const createContactLink = computed<string>(() => {
	return addContextParams("createContact.do", ctx.value, CONTACT_REFS);
});

interface MiniLink {
	days: number;
	link: string;
	label: string;
}

const miniLinks = computed<MiniLink[]>(() => {
	const ml:MiniLink[] = [];
	let days = 2;
	let date = shiftDate(new Date(), days);
	do {
		const weekDay = date.getDay();
		if (weekDay > 0 && weekDay < 6) {
			ml.push({ days, link: env.net.urlParam(createContactLink.value, "days", days), label: weekdayShortName(date) });
			days++;
		}
		shiftDate(date);
	} while (ml.length < 5);

	return ml;
});

</script>

<style>

</style>